// extracted by mini-css-extract-plugin
export default {"sortHeader":"SortHeader_sortHeader__Zh5F4","sortable":"SortHeader_sortable__OkGAJ"};